import { GenericFilter } from '@/components/GenericFilter';
import type { ListMediaFilterType, ListMediaFilterTypeWithValues } from '@shelflix/schemas/media/list';

export function MediaListFilter({ onChange }: { onChange: (filters: ListMediaFilterTypeWithValues) => void }) {
  const options: ListMediaFilterType = {
    search: {
      label: 'Nome',
      fields: ['name'],
    },
    sort: {
      label: 'Ordenar por',
      options: [
        { field: 'name', text: 'Alfabética A-Z', direction: 'asc' },
        { field: 'name', text: 'Alfabética Z-A', direction: 'desc' },
      ],
    },
  };

  return <GenericFilter options={options} onChange={onChange} />;
}
